import { Controller } from "@hotwired/stimulus";
import $ from "jquery";

export default class extends Controller {
  updateDeleteUrl(event) {
    $("#delete-favorite-link").attr("href", event.params.url);
  }
}
